import React from 'react';
import { GiftOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import CustomCards from './CutomCards.jsx';

import { ReactComponent as PointsToSendIcon } from './../../../assets/svg/pointstosend.svg';
import { ReactComponent as RecipientIcon } from './../../../assets/svg/recipientOne.svg';
import { ReactComponent as RewardIcon } from './../../../assets/svg/rewardOne.svg';

import './style.scss';

const RewardPointsAndBonus = (props) => {
	const {
		rewardPointsBonus,
		recognitionTotals,
		disableNominations,
		rewardsToClaimCount = 0,
	} = props;

	if (recognitionTotals) {
		return (
			<Card
				style={{
					border: '1px solid #dddddd',
					borderRadius: '14px',
					height: '100%',
				}}
				className="rewards-points"
				bodyStyle={{ padding: '16px' }}
			>
				<div>
					<h4
						style={{
							fontSize: '14px',
							lineHeight: '18px',
							fontWeight: 700,
							margin: '0 0 14px',
							color: 'var(--dove-gray)',
						}}
					>
						My Totals
					</h4>
				</div>
				<div
					className="reward-point-boxes"
					style={disableNominations ? { gridTemplateColumns: '1fr 1fr' } : null}
				>
					<CustomCards
						Icon={RewardIcon}
						customCardsClassName="reward-bonus"
						cardColor="oklch(0.6757 0.187 349.98)"
						pointAmount={recognitionTotals?.recognitions || 0}
						cardTitle={
							recognitionTotals?.recognitions === 1
								? 'Recognition'
								: 'Recognitions'
						}
					/>

					{!disableNominations && (
						<CustomCards
							Icon={PointsToSendIcon}
							cardColor="oklch(0.7903 0.136 192.97)"
							customCardsClassName="reward-bonus"
							pointAmount={recognitionTotals?.nominations || 0}
							cardTitle={'Points'}
						/>
					)}
					<CustomCards
						Icon={() => (
							<GiftOutlined style={{ fontSize: '3rem', color: 'white' }} />
						)}
						cardColor="oklch(0.58 0.26 295)"
						customCardsClassName="reward-bonus"
						pointAmount={recognitionTotals?.gifts || 0}
						cardTitle={recognitionTotals?.gifts === 1 ? 'Reward' : 'Rewards'}
						badgeText={
							rewardsToClaimCount > 0 ? `${rewardsToClaimCount} to claim` : null
						}
					/>
				</div>
			</Card>
		);
	}

	return (
		<Card
			style={{
				border: '1px solid #dddddd',
				borderRadius: '14px',
				height: '100%',
			}}
			className="rewards-points"
			bodyStyle={{ padding: '16px' }}
		>
			<div>
				<h4
					style={{
						fontSize: '14px',
						lineHeight: '18px',
						fontWeight: 700,
						margin: '0 0 14px',
						color: 'var(--dove-gray)',
					}}
				>
					My Totals
				</h4>
			</div>
			<div className="reward-point-boxes">
				<CustomCards
					Icon={PointsToSendIcon}
					customCardsClassName="reward-bonus"
					cardColor="#14D6D3"
					pointAmount={rewardPointsBonus?.totalEarned}
					cardTitle={'Total Points'}
				/>
				<CustomCards
					Icon={RewardIcon}
					cardColor="#e75da7"
					customCardsClassName="reward-bonus"
					pointAmount={rewardPointsBonus?.badges}
					cardTitle={
						rewardPointsBonus?.badges === 1 ? 'Recognition' : 'Recognitions'
					}
				/>
				<CustomCards
					Icon={RecipientIcon}
					cardColor="#813ae2"
					customCardsClassName="reward-bonus"
					pointAmount={rewardPointsBonus?.shoutOuts}
					cardTitle={
						rewardPointsBonus?.shoutOuts === 1 ? 'Mention' : 'Mentions'
					}
				/>
			</div>
		</Card>
	);
};

export default RewardPointsAndBonus;
